module.exports = __webpack_public_path__ + "static/media/black_friday.4b270d9d.pdf";